export const BASE_PATH = "/";
export const COPY_QUOTE_PATH = "copy-quote";
export const TEST_DT_LOGIN_PATH = "test-dt-login";
export const NOT_FOUND_PATH = "not-found";
export const SIGN_IN_PATH = "signin";
